<template>
  <img
    v-if="logoUrl"
    :src="logoUrl"
    style="height: 40px; max-width: 160px; object-fit: contain;"
    alt="Logo"
  >
  <svg
    v-else
    height="40"
    width="40"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <radialGradient id="tb-sg" cx="38%" cy="32%" r="70%">
        <stop offset="0%" stop-color="#818cf8" />
        <stop offset="55%" stop-color="#4f46e5" />
        <stop offset="100%" stop-color="#3730a3" />
      </radialGradient>
    </defs>
    <circle cx="16" cy="16" r="15.5" fill="#070b11" stroke="#4f46e5" stroke-width="0.8" />
    <polygon points="16,0.5  17.1,2.5  16,4.5  14.9,2.5" fill="#818cf8" />
    <polygon points="16,27.5 17.1,29.5 16,31.5 14.9,29.5" fill="#818cf8" />
    <polygon points="0.5,16  2.5,17.1 4.5,16  2.5,14.9" fill="#818cf8" />
    <polygon points="27.5,16 29.5,17.1 31.5,16 29.5,14.9" fill="#818cf8" />
    <g stroke="#4f46e5" stroke-width="0.9" stroke-linecap="round" opacity="0.7">
      <line x1="4" y1="4" x2="6" y2="6" />
      <line x1="28" y1="4" x2="26" y2="6" />
      <line x1="4" y1="28" x2="6" y2="26" />
      <line x1="28" y1="28" x2="26" y2="26" />
    </g>
    <circle cx="16" cy="16" r="13" fill="#0f172a" />
    <circle cx="16" cy="16" r="12.5" fill="none" stroke="#1e3a5f" stroke-width="0.5" />
    <path d="M 8,6  L 20,6  L 23,9  L 23,21  L 8,21  Z" fill="#08111f" stroke="#1e3a5f" stroke-width="0.8" />
    <path d="M 20,6  L 20,9  L 23,9  Z" fill="#0f1f33" />
    <path d="M 20,6  L 20,9  L 23,9" fill="none" stroke="#4f46e5" stroke-width="0.7" stroke-linejoin="round" />
    <g stroke="#2d4a6e" stroke-width="1.2" stroke-linecap="round">
      <line x1="10" y1="12.5" x2="21" y2="12.5" />
      <line x1="10" y1="15" x2="21" y2="15" />
      <line x1="10" y1="17.5" x2="17" y2="17.5" />
    </g>
    <circle cx="16.2" cy="20.2" r="5.5" fill="#070b11" opacity="0.4" />
    <circle cx="16" cy="19.8" r="5.5" fill="none" stroke="url(#tb-sg)" stroke-width="1.2" />
    <circle cx="16" cy="19.8" r="5" fill="url(#tb-sg)" />
    <circle cx="16" cy="19.8" r="4" fill="none" stroke="rgba(255,255,255,0.18)" stroke-width="0.8" />
    <path
      d="M 16,16.2 L 18.2,17 L 18.2,19.5 Q 18.2,21.8 16,22.4 Q 13.8,21.8 13.8,19.5 L 13.8,17 Z"
      fill="rgba(255,255,255,0.06)"
      stroke="rgba(255,255,255,0.85)"
      stroke-width="0.85"
      stroke-linejoin="round"
    />
    <path
      d="M 14.5,19.6  L 16,21.2  L 18.2,17.8"
      stroke="white"
      stroke-width="1.1"
      fill="none"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'ProjectLogo',
  data () {
    return {
      logoUrl: document.querySelector('meta[name="account-logo-url"]')?.content || null
    }
  }
}
</script>
